export default "__VITE_ASSET__8e69af67__"